import { useEffect } from 'react';

interface AdSenseProps {
  adSlot: string;
  adFormat?: string;
  fullWidthResponsive?: boolean;
  style?: React.CSSProperties;
}

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

export default function AdSense({
  adSlot,
  adFormat = 'auto',
  fullWidthResponsive = true,
  style = { display: 'block' }
}: AdSenseProps) {
  useEffect(() => {
    const originalConsoleError = console.error;
    console.error = (...args: unknown[]) => {
      const message = String(args[0]);
      if (
        message.includes('adsbygoogle.push') ||
        message.includes('TagError') ||
        message.includes('No slot size for availableWidth')
      ) {
        return;
      }
      originalConsoleError.apply(console, args);
    };

    try {
      if (window.adsbygoogle && process.env.NODE_ENV === 'production') {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      // Suppress AdSense errors
    }

    return () => {
      console.error = originalConsoleError;
    };
  }, []);

  return (
    <div style={{ minHeight: '100px', minWidth: '250px' }}>
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client="ca-pub-6164309932336762"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive ? 'true' : 'false'}
      />
    </div>
  );
}
